import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loading-error-page" }
const _hoisted_2 = { class: "loading-error-container" }
const _hoisted_3 = { class: "loading-error-frame" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16 10.5C16.5531 10.5 17 10.9469 17 11.5V12.5C17 13.0531 16.5531 13.5 16 13.5H8C7.44688 13.5 7 13.0531 7 12.5V11.5C7 10.9469 7.44688 10.5 8 10.5H16ZM20 12C20 16.4187 16.4187 20 12 20C7.58125 20 4 16.4187 4 12C4 7.58125 7.58125 4 12 4C16.4187 4 20 7.58125 20 12ZM12 5.5C8.40938 5.5 5.5 8.40938 5.5 12C5.5 15.5906 8.40938 18.5 12 18.5C15.5906 18.5 18.5 15.5906 18.5 12C18.5 8.40938 15.5906 5.5 12 5.5Z",
    fill: "#BA1A1A"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "loading-error-title" }, " We’re Experiencing Technical Difficulties ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "loading-error-subtitle" }, " Please contact support and let them know the Encoder is not working. Thank you for your patience. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "loading-error-button-state-layer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "loading-error-button-text" }, " Close Encoder ")
], -1)

import { useLayoutStore } from 'stores/layout-store';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingError',
  setup(__props) {

  const layoutStore = useLayoutStore();
  const onClose = () => {
    layoutStore.requestClose();
  }

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_q_btn, {
          flat: "",
          class: "loading-error-button",
          onClick: onClose
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})